//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IDocumentS1DownloadenEndpointClient {
    /**
     * @return Success
     */
    documentS1Downloaden(): Promise<FileResponse>;
}

export class DocumentS1DownloadenEndpointClient implements IDocumentS1DownloadenEndpointClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    documentS1Downloaden( cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/klantcontact/document-s1-downloaden";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentS1Downloaden(_response);
        });
    }

    protected processDocumentS1Downloaden(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IDocumentS1OpsturenEndpointClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    documentS1Opsturen(body?: DocumentS1OpsturenCommand | undefined): Promise<KlantContactResponse>;
}

export class DocumentS1OpsturenEndpointClient implements IDocumentS1OpsturenEndpointClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    documentS1Opsturen(body?: DocumentS1OpsturenCommand | undefined, cancelToken?: CancelToken | undefined): Promise<KlantContactResponse> {
        let url_ = this.baseUrl + "/api/v1/klantcontact/document-s1-opsturen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentS1Opsturen(_response);
        });
    }

    protected processDocumentS1Opsturen(response: AxiosResponse): Promise<KlantContactResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KlantContactResponse.fromJS(resultData200);
            return Promise.resolve<KlantContactResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KlantContactResponse>(null as any);
    }
}

export interface IEhicAanvragenEndpointClient {
    ehicAanvragen(body?: EhicAanvragenCommand | undefined): Promise<void>;
}

export class EhicAanvragenEndpointClient implements IEhicAanvragenEndpointClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    ehicAanvragen(body?: EhicAanvragenCommand | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/klantcontact/ehic-aanvragen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEhicAanvragen(_response);
        });
    }

    protected processEhicAanvragen(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IMedicatielijstOpvragenEndpointClient {
    /**
     * @return Success
     */
    medicatielijstOpvragen(): Promise<MedicatieItem[]>;
}

export class MedicatielijstOpvragenEndpointClient implements IMedicatielijstOpvragenEndpointClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    medicatielijstOpvragen( cancelToken?: CancelToken | undefined): Promise<MedicatieItem[]> {
        let url_ = this.baseUrl + "/api/v1/klantcontact/medicatielijst-opvragen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMedicatielijstOpvragen(_response);
        });
    }

    protected processMedicatielijstOpvragen(response: AxiosResponse): Promise<MedicatieItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MedicatieItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MedicatieItem[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MedicatieItem[]>(null as any);
    }
}

export interface ISchengenverklaringDownloadenEndpointClient {
    /**
     * @return Success
     */
    schengenverklaringDownloaden(): Promise<FileResponse>;
}

export class SchengenverklaringDownloadenEndpointClient implements ISchengenverklaringDownloadenEndpointClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    schengenverklaringDownloaden( cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/klantcontact/schengenverklaring-downloaden";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchengenverklaringDownloaden(_response);
        });
    }

    protected processSchengenverklaringDownloaden(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ISchengenverklaringOpsturenEndpointClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    schengenverklaringOpsturen(body?: SchengenverklaringOpsturenCommand | undefined): Promise<KlantContactResponse>;
}

export class SchengenverklaringOpsturenEndpointClient implements ISchengenverklaringOpsturenEndpointClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    schengenverklaringOpsturen(body?: SchengenverklaringOpsturenCommand | undefined, cancelToken?: CancelToken | undefined): Promise<KlantContactResponse> {
        let url_ = this.baseUrl + "/api/v1/klantcontact/schengenverklaring-opsturen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchengenverklaringOpsturen(_response);
        });
    }

    protected processSchengenverklaringOpsturen(response: AxiosResponse): Promise<KlantContactResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KlantContactResponse.fromJS(resultData200);
            return Promise.resolve<KlantContactResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KlantContactResponse>(null as any);
    }
}

export class Bijlage implements IBijlage {
    bestandsnaam!: string;
    base64Inhoud?: string | null;

    constructor(data?: IBijlage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bestandsnaam = _data["bestandsnaam"] !== undefined ? _data["bestandsnaam"] : <any>null;
            this.base64Inhoud = _data["base64Inhoud"] !== undefined ? _data["base64Inhoud"] : <any>null;
        }
    }

    static fromJS(data: any): Bijlage {
        data = typeof data === 'object' ? data : {};
        let result = new Bijlage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bestandsnaam"] = this.bestandsnaam !== undefined ? this.bestandsnaam : <any>null;
        data["base64Inhoud"] = this.base64Inhoud !== undefined ? this.base64Inhoud : <any>null;
        return data;
    }
}

export interface IBijlage {
    bestandsnaam: string;
    base64Inhoud?: string | null;
}

export class DocumentS1OpsturenCommand implements IDocumentS1OpsturenCommand {
    naam!: string;
    geboortenaam?: string | null;
    telefoonnummer?: string | null;
    email!: string;
    bijlagen!: Bijlage[];

    constructor(data?: IDocumentS1OpsturenCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.bijlagen) {
                this.bijlagen = [];
                for (let i = 0; i < data.bijlagen.length; i++) {
                    let item = data.bijlagen[i];
                    this.bijlagen[i] = item && !(<any>item).toJSON ? new Bijlage(item) : <Bijlage>item;
                }
            }
        }
        if (!data) {
            this.bijlagen = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naam = _data["naam"] !== undefined ? _data["naam"] : <any>null;
            this.geboortenaam = _data["geboortenaam"] !== undefined ? _data["geboortenaam"] : <any>null;
            this.telefoonnummer = _data["telefoonnummer"] !== undefined ? _data["telefoonnummer"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            if (Array.isArray(_data["bijlagen"])) {
                this.bijlagen = [] as any;
                for (let item of _data["bijlagen"])
                    this.bijlagen!.push(Bijlage.fromJS(item));
            }
            else {
                this.bijlagen = <any>null;
            }
        }
    }

    static fromJS(data: any): DocumentS1OpsturenCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentS1OpsturenCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naam"] = this.naam !== undefined ? this.naam : <any>null;
        data["geboortenaam"] = this.geboortenaam !== undefined ? this.geboortenaam : <any>null;
        data["telefoonnummer"] = this.telefoonnummer !== undefined ? this.telefoonnummer : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        if (Array.isArray(this.bijlagen)) {
            data["bijlagen"] = [];
            for (let item of this.bijlagen)
                data["bijlagen"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentS1OpsturenCommand {
    naam: string;
    geboortenaam?: string | null;
    telefoonnummer?: string | null;
    email: string;
    bijlagen: IBijlage[];
}

export class EhicAanvragenCommand implements IEhicAanvragenCommand {
    cakIdNummer!: string;
    geboortedatum!: Date;
    email!: string;

    constructor(data?: IEhicAanvragenCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cakIdNummer = _data["cakIdNummer"] !== undefined ? _data["cakIdNummer"] : <any>null;
            this.geboortedatum = _data["geboortedatum"] ? new Date(_data["geboortedatum"].toString()) : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): EhicAanvragenCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EhicAanvragenCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cakIdNummer"] = this.cakIdNummer !== undefined ? this.cakIdNummer : <any>null;
        data["geboortedatum"] = this.geboortedatum ? this.geboortedatum.toISOString() : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data;
    }
}

export interface IEhicAanvragenCommand {
    cakIdNummer: string;
    geboortedatum: Date;
    email: string;
}

export class KlantContactResponse implements IKlantContactResponse {
    klantContactId?: number;
    bericht?: string | null;

    constructor(data?: IKlantContactResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.klantContactId = _data["klantContactId"] !== undefined ? _data["klantContactId"] : <any>null;
            this.bericht = _data["bericht"] !== undefined ? _data["bericht"] : <any>null;
        }
    }

    static fromJS(data: any): KlantContactResponse {
        data = typeof data === 'object' ? data : {};
        let result = new KlantContactResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["klantContactId"] = this.klantContactId !== undefined ? this.klantContactId : <any>null;
        data["bericht"] = this.bericht !== undefined ? this.bericht : <any>null;
        return data;
    }
}

export interface IKlantContactResponse {
    klantContactId?: number;
    bericht?: string | null;
}

export class MedicatieItem implements IMedicatieItem {
    position!: number;
    key!: string;
    label!: string;

    constructor(data?: IMedicatieItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"] !== undefined ? _data["position"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
        }
    }

    static fromJS(data: any): MedicatieItem {
        data = typeof data === 'object' ? data : {};
        let result = new MedicatieItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position !== undefined ? this.position : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        return data;
    }
}

export interface IMedicatieItem {
    position: number;
    key: string;
    label: string;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;
}

export class SchengenverklaringOpsturenCommand implements ISchengenverklaringOpsturenCommand {
    vertrekdatum!: Date;
    voorletters!: string;
    achternaam!: string;
    telefoonnummer?: string | null;
    opmerking?: string | null;
    email!: string;
    emailBevestigingOntvangen!: boolean;
    bijlagen!: Bijlage[];

    constructor(data?: ISchengenverklaringOpsturenCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.bijlagen) {
                this.bijlagen = [];
                for (let i = 0; i < data.bijlagen.length; i++) {
                    let item = data.bijlagen[i];
                    this.bijlagen[i] = item && !(<any>item).toJSON ? new Bijlage(item) : <Bijlage>item;
                }
            }
        }
        if (!data) {
            this.bijlagen = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vertrekdatum = _data["vertrekdatum"] ? new Date(_data["vertrekdatum"].toString()) : <any>null;
            this.voorletters = _data["voorletters"] !== undefined ? _data["voorletters"] : <any>null;
            this.achternaam = _data["achternaam"] !== undefined ? _data["achternaam"] : <any>null;
            this.telefoonnummer = _data["telefoonnummer"] !== undefined ? _data["telefoonnummer"] : <any>null;
            this.opmerking = _data["opmerking"] !== undefined ? _data["opmerking"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.emailBevestigingOntvangen = _data["emailBevestigingOntvangen"] !== undefined ? _data["emailBevestigingOntvangen"] : <any>null;
            if (Array.isArray(_data["bijlagen"])) {
                this.bijlagen = [] as any;
                for (let item of _data["bijlagen"])
                    this.bijlagen!.push(Bijlage.fromJS(item));
            }
            else {
                this.bijlagen = <any>null;
            }
        }
    }

    static fromJS(data: any): SchengenverklaringOpsturenCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SchengenverklaringOpsturenCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vertrekdatum"] = this.vertrekdatum ? this.vertrekdatum.toISOString() : <any>null;
        data["voorletters"] = this.voorletters !== undefined ? this.voorletters : <any>null;
        data["achternaam"] = this.achternaam !== undefined ? this.achternaam : <any>null;
        data["telefoonnummer"] = this.telefoonnummer !== undefined ? this.telefoonnummer : <any>null;
        data["opmerking"] = this.opmerking !== undefined ? this.opmerking : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["emailBevestigingOntvangen"] = this.emailBevestigingOntvangen !== undefined ? this.emailBevestigingOntvangen : <any>null;
        if (Array.isArray(this.bijlagen)) {
            data["bijlagen"] = [];
            for (let item of this.bijlagen)
                data["bijlagen"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISchengenverklaringOpsturenCommand {
    vertrekdatum: Date;
    voorletters: string;
    achternaam: string;
    telefoonnummer?: string | null;
    opmerking?: string | null;
    email: string;
    emailBevestigingOntvangen: boolean;
    bijlagen: IBijlage[];
}

export class ValidationProblemDetails implements IValidationProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    errors?: { [key: string]: string[]; } | null;

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
            else {
                this.errors = <any>null;
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = this.errors[key] !== undefined ? this.errors[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IValidationProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    errors?: { [key: string]: string[]; } | null;

    [key: string]: any;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ClientApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isClientApiException = true;

    static isClientApiException(obj: any): obj is ClientApiException {
        return obj.isClientApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ClientApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}